import {
  getCurrentStorageName,
  getObjectFromSession,
  setObjectToSession,
} from '@/utils/session-utils';

import {
  INIT_STATE,
  SET_CURRENT_PAGE,
  SET_CURRENT_SESSION_STATE,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_EMPRESA,
  SET_FILTER,
  SET_FORNECEDOR,
  SET_LIST_OPTIONS,
  SET_OFFSET,
  SET_SEARCH_TEXT,
  SET_SELECTED_STATUS,
  SET_NOTAS_SEM_VINCULO,
} from './mutations.type';

import { PREFIX_SESSION_STATE_NAME } from './constants';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
  [SET_FORNECEDOR](state, fornecedor) {
    state.fornecedor = fornecedor;
  },
  [SET_NOTAS_SEM_VINCULO](state, notasSemVinculo) {
    state.notasSemVinculo = notasSemVinculo;
  },
  [SET_CURRENT_PAGE](state, page) {
    state.listOptions.page = page;
  },
  [SET_FILTER](state, filter) {
    state.listOptions.filter = filter;
  },
  [SET_OFFSET](state, offset) {
    state.listOptions.offset = offset;
  },
  [SET_LIST_OPTIONS](state, listOptions) {
    state.listOptions = listOptions;
  },
  [SET_CURRENT_SESSION_STATE](state, ids) {
    const stateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );

    if (stateName) {
      setObjectToSession(stateName, state);
    }
  },
  [INIT_STATE](state, ids) {
    const currentStateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    const sessionObjectState = getObjectFromSession(currentStateName);

    const selectedStatus = sessionObjectState?.selectedStatus || state.selectedStatus;
    state.selectedStatus = state.statusOptions.find(s => s.id === selectedStatus?.id)
      || state.statusOptions[0];
    state.searchText = sessionObjectState?.searchText || state.searchText;
    state.empresa = sessionObjectState?.empresa || state.empresa;
    state.fornecedor = sessionObjectState?.fornecedor || state.fornecedor;
    state.dataFinal = sessionObjectState?.dataFinal || state.dataFinal;
    state.dataInicial = sessionObjectState?.dataInticial || state.dataInticial;
    state.listOptions = sessionObjectState?.listOptions || state.listOptions;
  },
};
